<template>
  <div>
    <div class="wrapper">
      <div class="animated fadeIn">
        <b-form @submit.prevent="saveItem">
          <b-row>
            <b-col cols="12" class="mb-3">
              <b-button variant="primary" @click="$router.go(-1)" class="pull-left">
                Terug
              </b-button>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-tabs>
                <b-tab title="Basisgegevens" active>
                  <b-row>
                    <b-col cols="12">
                      <b-row>
                        <b-col>
                          <h5>Basisgegevens</h5>
                          <hr>
                          <b-row>
                            <b-col cols="12" md="6">
                              <b-form-group label="Campagne">
                                <b-form-input type="text" required v-model="item.campaign" :disabled="!editable"></b-form-input>
                              </b-form-group>
                            </b-col>
                            <b-col cols="12" md="6">
                              <b-form-group label="Actief">
                                <b-form-select required :options="isActiveOptions" v-model="item.is_active" :disabled="!editable"/>
                              </b-form-group>
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col>
                          <hr>
                          <div v-if="editable && userRole === 'admin'">
                            <b-button @click.prevent="cancelEdit" class="mr-3" variant="warning">Annuleren</b-button>
                            <b-button type="submit" variant="success" class="pull-right" :disabled="saveButtonDisabled">
                              Wijzigingen opslaan
                            </b-button>
                          </div>
                          <div v-if="!editable && userRole === 'admin'">
                            <b-button type="button" @click.prevent="editable = true" variant="primary" class="pull-right">
                              Bewerken
                            </b-button>
                          </div>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </b-tab>
                <b-tab title="Vragen">
                  <question v-for="(question, index) in this.item.questions" :question="question" :count="index" v-on:refresh="getItem()"/>
                  <b-row>
                    <b-col>
                      <hr v-if="userRole === 'admin'">
                      <b-button type="button" v-b-modal.add-question variant="primary" class="pull-right" v-if="userRole === 'admin'">
                        Vraag toevoegen
                      </b-button>
                      <b-modal id="add-question" title="Vraag toevoegen" hide-footer>
                        <b-row>
                          <b-col>
                            <b-form-group label="Titel">
                              <b-form-input type="text" required v-model="newItem.title"></b-form-input>
                            </b-form-group>
                          </b-col>
                          <b-col>
                            <b-form-group label="Type vraag">
                              <b-form-select :options="questionTypes" type="text" v-model="newItem.type" required></b-form-select>
                            </b-form-group>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col>
                            <b-form-group label="Vraag">
                              <b-textarea rows="3" v-model="newItem.question" required/>
                            </b-form-group>
                            <b-form-group label="Antwoorden" v-if="newItem.type === 'select'">
                              <table class="table table-bordered">
                                <tr v-for="(answer, index) in newItem.answers">
                                  <td>
                                    <b-form-input type="text" v-model="newItem.answers[index].text" required></b-form-input>
                                  </td>
                                  <td>
                                    <i class="icon-close icons mt-2 h5 d-inline-block text-danger" style="cursor: pointer;" @click="newItem.answers.splice(index,1)"></i>
                                  </td>
                                </tr>
                              </table>
                              <span class="text-success pull-right" @click="addAnswer()" style="cursor: pointer;">
                                Antwoord toevoegen
                                <i class="icon-plus icons mt-3 d-inline-block"></i>
                              </span>
                            </b-form-group>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col>
                            <b-button type="button" @click="addQuestion()" variant="primary" class="pull-right">
                              Vraag toevoegen
                            </b-button>
                          </b-col>
                        </b-row>
                      </b-modal>
                    </b-col>
                  </b-row>
                </b-tab>
              </b-tabs>
            </b-col>
          </b-row>
        </b-form>
      </div>
    </div>
  </div>
</template>
<script>
import {updateData, getData, addData} from '@/api';
import Question from "./components/Question";

export default {
  name: 'campaign-action',
  components: {Question},
  props: ['id'],
  data() {
    return {
      saveButtonDisabled: false,
      newItem: {
        type: null,
        title: '',
        question: '',
        answers: []
      },
      editable: false,
      item: {},
      isActiveOptions: [
        {
          text: 'Ja',
          value: 1
        },
        {
          text: 'Nee',
          value: 0
        },
      ],
      questionTypes: [
        {
          text: 'Open',
          value: 'open'
        },
        {
          text: 'E-mail',
          value: 'email'
        },
        {
          text: 'Smiley',
          value: 'smiley'
        },
        {
          text: 'Meerkeuzevraag',
          value: 'select'
        },
        {
          text: 'Schaal (1-5)',
          value: 'scale'
        },
        {
          text: 'QR',
          value: 'qr'
        },
        {
          text: 'Extra vraag',
          value: 'extra_question'
        }
      ],
    };
  },
  methods: {
    async getItem() {
      this.item = await getData('questionnaires/' + this.$route.params.id).then(
        (response) => response.data.data
      );
    },
    async saveItem() {
      this.saveButtonDisabled = true;
      const request = await updateData(
        'questionnaires/' + this.$route.params.id,
        {
          name: this.item.campaign,
          campaign: this.item.campaign,
          is_active: this.item.is_active
        }
      );
      if (request.status === 200) {
        this.editable = false;
        this.saveButtonDisabled = false;
        await this.getItem();
      } else {
        this.editable = true;
        this.saveButtonDisabled = false;
      }
    },
    async addQuestion() {
      this.saveButtonDisabled = true;
      const request = await addData(
        'questionnaires/' + this.$route.params.id + '/questions',
        {
          type: this.newItem.type,
          title: this.newItem.title,
          question: this.newItem.question,
          answers: this.newItem.answers
        }
      );
      if (request.status === 200) {
        this.editable = false;
        this.saveButtonDisabled = false;
        await this.getItem();
        this.$bvModal.hide('add-question');
        this.newItem = {};
      } else {
        this.editable = true;
        this.saveButtonDisabled = false;
      }
    },
    addAnswer() {
      this.newItem.answers.push({
        text: '',
        value: ''
      })
    },
    cancelEdit() {
      this.editable = false;
      this.getItem();
    },
  },
  computed: {
    userRole: function () {
      return this.$store.state.userRole;
    },
  },
  beforeMount() {
    this.getItem();
  },
};

</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
